var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('p',[_vm._v("Hello Admin: "+_vm._s(_vm.$store.state.user.username)+" , Welcome~")])])
}
var staticRenderFns = []

export { render, staticRenderFns }